<script setup lang="ts">
import { computed } from "vue";
import AiScreeningPanel from "@/components/recruitment/AiScreeningPanel.vue";

const application = defineModel<any>({ required: true });

const summary = computed(() => application.value?.aiScreening?.overallSummary || "");
const hasSummary = computed(
  () => application.value?.aiScreening?.status === "completed" && Boolean(summary.value),
);
</script>

<template>
  <div
    v-if="hasSummary"
    class="flex shrink-0 items-start gap-3 rounded-lg border border-base bg-fade px-3 py-2"
    data-cy="screening-review-ai-summary"
  >
    <AiScreeningPanel :ai-screening="application.aiScreening" compact />
    <p class="min-w-0 flex-1 text-sm leading-5" data-cy="screening-review-ai-text">
      {{ summary }}
    </p>
  </div>
</template>
